import { useTranslation } from 'react-i18next';

type Props = {
  options?: Intl.NumberFormatOptions;
  value: number;
};

export function FormattedNumber({ value, options }: Props): React.ReactNode {
  const { i18n } = useTranslation();

  const formattedNumber = new Intl.NumberFormat(i18n.language, options).format(value);

  return formattedNumber;
}
